export const emailIpWarmingAppGroupIdCampaignStats = "/email/ip_warming/:app_group_id/campaign_stats(/:plan_id)";
